import api from './api'

export async function getStats() {
  const { data } = await api.get('/admin/stats')
  return data
}

export async function getOrders(params = {}) {
  const { data } = await api.get('/admin/orders', { params })
  return data
}

export async function updateOrderStatus(id, payload) {
  const { data } = await api.patch(`/admin/orders/${encodeURIComponent(id)}/status`, payload)
  return data
}

export async function getProductById(id) {
  const { data } = await api.get(`/admin/products/${encodeURIComponent(id)}`)
  return data
}

export async function createProduct(payload) {
  const { data } = await api.post('/admin/products', payload)
  return data
}

export async function updateProduct(id, payload) {
  const { data } = await api.put(`/admin/products/${encodeURIComponent(id)}`, payload)
  return data
}

export async function deleteProduct(id) {
  const { data } = await api.delete(`/admin/products/${encodeURIComponent(id)}`)
  return data
}

/**
 * Upload image for admin (e.g. product image).
 * @param {File} file
 * @returns {Promise<{ success: boolean, url: string }>}
 */
export async function uploadImage(file) {
  const formData = new FormData()
  formData.append('image', file)
  const { data } = await api.post('/admin/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return data
}
